import { render, staticRenderFns } from "./entity-select-table.vue?vue&type=template&id=0183f08b&scoped=true&"
import script from "./entity-select-table.ts?vue&type=script&lang=ts&"
export * from "./entity-select-table.ts?vue&type=script&lang=ts&"
import style0 from "./entity-select-table.scss?vue&type=style&index=0&id=0183f08b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0183f08b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
